import { createHttpClient } from '@adapters/HttpClient';
import { CourierInvoicesApiAdapter } from '../../adapters';
import type { CourierInvoiceDetail } from '../../models/types';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

export const useCourierInvoiceDetail = (invoiceId: number | undefined) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new CourierInvoicesApiAdapter(httpClient), [httpClient]);

  return useQuery<CourierInvoiceDetail, Error>({
    queryKey: ['courier-invoice-detail', invoiceId],
    queryFn: () => adapter.detail(invoiceId as number),
    enabled: typeof invoiceId === 'number' && invoiceId > 0,
    staleTime: 30 * 1000,
  });
};
